/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_04_DescInputs */

const en_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const de_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hör auf, überall denselben Lebenslauf zu schicken. Fang an, Einladungen zu bekommen.`)
};

const fr_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const es_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const it_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const nl_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const pl_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const fi_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const da_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

const sv_landing_section_04_desc = /** @type {(inputs: Landing_Section_04_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop sending the same resume everywhere. Start getting interviews.`)
};

/**
* | output |
* | --- |
* | "Stop sending the same resume everywhere. Start getting interviews." |
*
* @param {Landing_Section_04_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_04_desc = /** @type {((inputs?: Landing_Section_04_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_04_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_04_desc(inputs)
	if (locale === "fr") return fr_landing_section_04_desc(inputs)
	if (locale === "es") return es_landing_section_04_desc(inputs)
	if (locale === "it") return it_landing_section_04_desc(inputs)
	if (locale === "nl") return nl_landing_section_04_desc(inputs)
	if (locale === "pl") return pl_landing_section_04_desc(inputs)
	if (locale === "fi") return fi_landing_section_04_desc(inputs)
	if (locale === "da") return da_landing_section_04_desc(inputs)
	if (locale === "sv") return sv_landing_section_04_desc(inputs)
	return en_landing_section_04_desc(inputs)
});